



































import { IEntity, IEntityImporter } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { EEntityImportState, EEntityMatchType } from '@/components/Importer/enums';
import ImportsTableRow from '@/components/Importer/ImportsTableRow.vue';
import PropertyUpdateTable from '@/components/Importer/PropertyUpdateTable.vue';
import TransportationPermission from '@/components/Passenger/models/TransportationPermission';

@Component({
  components: {
    ImportsTableRow,
    PropertyUpdateTable,
  },
})
export default class TransportationPermissionImportsTable extends Vue {

  selectedItems: Array<IEntity<TransportationPermission>> = [];

  pagination = {
    descending: true,
    page: 1,
    rowsPerPage: -1, // -1 for All
    sortBy: 'name',
  };

  @Prop({ required: true }) ptpImporter: IEntityImporter<TransportationPermission>;
  @Watch('ptpImporter', { immediate: true }) onPassengerImporterChanged() {
    this.selectedItems = [];
    if (!this.ptpImporter) {
      return;
    }
    const selectedEntities = this.ptpImporter.entities.filter(x => x && x.entity).filter(e => e.selected);
    this.selectedItems = selectedEntities;
  }

  get headers() {
    return [
      { value: 'passengerName', text: this.$t('passenger.prop.name.label', 'Name') },
      { value: 'name', text: this.$t('transportationPermission.name', 'Transportation permission name') },
      { value: 'startDate', text: this.$t('transportationPermission.startDate', 'Starts from') },
      { value: 'endDate', text: this.$t('transportationPermission.endDate', 'Valid through') },
      { value: 'costCenter', text: this.$t('transportationPermission.costCenter', 'Cost center / Account key') },
      { value: 'note', text: this.$t('transportationPermission.note', 'Reason') },
    ];
  }

  get items() {
    const entities = this.ptpImporter.entities.filter(x => x && x.entity);
    return entities;
  }

  toggleAll() {
    if (this.selectedItems.length) {
      this.selectedItems = [];
      this.items.forEach(i => i.selected = false);
      return;
    }
    this.items.forEach(i => i.selected = true);
    this.selectedItems = this.items;
  }

  selectRow(row: IEntity<any>) {
    this.$emit('selectRow', row);
  }

}
